import { Injectable } from '@angular/core';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private apiHelper: ApiHelper) { }

  list() {
    return this.apiHelper.get(API_URLS.CLIENT)
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.CLIENT, payload)
  }

  update(id: any, payload: any) {
    return this.apiHelper.put(`${API_URLS.CLIENT}/${id}`, payload)
  }

  info(id: any) {
    return this.apiHelper.get(`${API_URLS.CLIENT}/${id}`)
  }
}
